import { View } from 'react-native';
import { styles } from './PagerList.styles';

type PagerStatus = 'active' | 'inactive' | 'crossed';

type PagerListProps = {
  list: number[];
  activePager: number;
};

const getPagerStatus = (
  currentItem: number,
  activeItem: number,
): PagerStatus => {
  if (currentItem === activeItem) {
    return 'active';
  }
  if (currentItem < activeItem) {
    return 'crossed';
  }
  return 'inactive';
};

export const PagerList = ({ list, activePager }: PagerListProps) => {
  return (
    <View style={styles.container}>
      {list.map((item, index) => {
        const status = getPagerStatus(item, activePager);
        return <PagerItem key={index} pagerStatus={status} />;
      })}
    </View>
  );
};

const PagerItem = ({ pagerStatus }: { pagerStatus: PagerStatus }) => {
  return <View style={[styles.dot, styles[pagerStatus]]} />;
};
